<app-breadcrumb [master]="'Rejestracje'" [parentName]="'Egzaminy i szkolenia'" [name]="'Szczegóły'"></app-breadcrumb>
<mat-tab-group>
  <mat-tab label="Dane">
    <app-meeting-details-view *ngIf="!modify" [meeting]="meeting" (modifyClicked)="modify = true"></app-meeting-details-view>
    <app-meeting-add *ngIf="modify" [meeting]="meeting" (closeModification)="modify = false; loadMeeting()"></app-meeting-add>
  </mat-tab>
  <mat-tab label="OFWCA do zapisania" *ngIf="meetingObject
  && meetingObject.status.key === MEETING_STATUS_DURING_REGISTRATIONS
  && meetingObject.placesLeft !== 0
  && meetingObject.type.key !== MEETING_TYPE_ADA && meetingObject.type.key !== MEETING_TYPE_TRAINING &&
  meetingObject.type.key !== MEETING_TYPE_MEETING && meetingObject.type.key !== MEETING_TYPE_OTHER
">
    <ng-template matTabContent>
      <app-ofwca-to-register-list (changed)="loadMeeting()" [meeting]="meeting"></app-ofwca-to-register-list>
    </ng-template>
  </mat-tab>
  <mat-tab label="Zapisane OFWCA" *ngIf="meetingObject && meetingObject.type.key !== MEETING_TYPE_ADA && meetingObject.type.key !== MEETING_TYPE_TRAINING &&
  meetingObject.type.key !== MEETING_TYPE_MEETING && meetingObject.type.key !== MEETING_TYPE_OTHER">
    <ng-template matTabContent>
      <app-registered-ofwcas-list (changed)="loadMeeting()" [meeting]="meeting"></app-registered-ofwcas-list>
    </ng-template>
  </mat-tab>
  <mat-tab label="Historia zmian">
    <ng-template matTabContent>
      <app-log-list [meeting]="meeting"></app-log-list>
    </ng-template>
  </mat-tab>
</mat-tab-group>
